import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export const INFUSION_SUSPEND_FIELD_STEP_VALIDATOR = 'infusion-suspend-field-step-validador';
export const INFUSION_SUSPEND_FIELD_REASON_VALIDATOR = 'infusion-suspend-field-reason-validador';
export const INFUSION_SUSPEND_FIELD_JUSTIFICATION_VALIDATOR = 'infusion-suspend-field-justification-validador';
export async function infusionSuspendFieldJustificationValidator(value) {
    if (!value) {
        return [
            {
                message: MessageService.translate('message.infusion-suspend.require-justification'),
                name: INFUSION_SUSPEND_FIELD_JUSTIFICATION_VALIDATOR,
                valid: false,
            },
        ];
    }
    return [
        {
            message: '',
            name: INFUSION_SUSPEND_FIELD_JUSTIFICATION_VALIDATOR,
            valid: true,
        },
    ];
}
export async function infusionSuspendFieldReasonValidator(value) {
    if (!value) {
        return [
            {
                message: MessageService.translate('message.infusion-suspend.require-reason'),
                name: INFUSION_SUSPEND_FIELD_REASON_VALIDATOR,
                valid: false,
            },
        ];
    }
    return [
        {
            message: '',
            name: INFUSION_SUSPEND_FIELD_REASON_VALIDATOR,
            valid: true,
        },
    ];
}
export async function infusionSuspendFieldStepValidator(value) {
    if (!value) {
        return [
            {
                message: MessageService.translate('message.infusion-suspend.require-step'),
                name: INFUSION_SUSPEND_FIELD_STEP_VALIDATOR,
                valid: false,
            },
        ];
    }
    return [
        {
            message: '',
            name: INFUSION_SUSPEND_FIELD_STEP_VALIDATOR,
            valid: true,
        },
    ];
}
//# sourceMappingURL=infusion-validator.js.map